import api from '@/api/legacy/api';
import { endpoints } from '@/config';
import { ns } from '@/helpers/store';
import { ACCOUNT_KEY } from '@/store/modules/role';
import { FETCH_ACCOUNT, FETCH_ACCOUNTS, FETCH_ALL, FETCH_FILTERS, FETCH_KPIS, FETCH_SETTINGS, FETCH_UI_METADATA, RESTORE_ACCOUNT, SET_LEGACY_ACCOUNT } from '@/store/types/actions';
import { ACCOUNT, FILTERS, ROLE, SETTINGS, UI } from '@/store/types/namespaces';
import { apolloSdk } from '../../api/apollo';

export const actions = {
  [FETCH_ALL]({ dispatch }, { setProgress = () => {} }) {
    let accountId;
    return Promise.all([
      dispatch(ns(ROLE, FETCH_ACCOUNTS)),
      dispatch(ns(ROLE, RESTORE_ACCOUNT)),
    ])
      // .then(() => dispatch(ns(USER, FETCH_USER)))
      .then(() => {
        setProgress(25);
        // Find the real name of the account from the new organisations
        accountId = window.localStorage.getItem(ACCOUNT_KEY);
        return Promise.all([
          dispatch(ns(ACCOUNT, FETCH_ACCOUNT), accountId),
          dispatch(ns(ROLE, SET_LEGACY_ACCOUNT), { id: accountId }),
        ]);
      })
      .then(() => {
        setProgress(50);
        return Promise.all([
          dispatch(ns(SETTINGS, FETCH_SETTINGS)),
          dispatch(ns(UI, FETCH_UI_METADATA)),
        ]);
      })
      .then(() => {
        setProgress(75);
        // hits GET /dashboards to create default dashboards if none
        return api.get(endpoints.dashboards)
          .then(() => Promise.all([
            // HACK: populate the apollo cache, as most consumers of
            // useListableProperties expect it to be populated immediately.
            apolloSdk.Properties({ accountId }),
            dispatch(ns(FILTERS, FETCH_FILTERS)),
            dispatch(FETCH_KPIS),
          ]));
      });
  },
};

export const getters = {
  legacyUserSettings(a, b, rootState) {
    return rootState[SETTINGS].legacy.userSettings;
  },
};
